import { InfoCircle, LinkExternal01 } from '#app/components/icons/duotone'
import { DialogTrigger } from 'react-aria-components'
import { Button } from '#app/components/base/buttons/button.js'
import { Popover } from '#app/components/base/select/popover.js'

export const IconGroupLicensePopover = ({
	name,
	author,
	authorUrl,
	license,
}: {
	name: string
	author: string | null
	authorUrl: string | null
	license: string | null
}) => {
	return (
		<DialogTrigger>
			<Button iconLeading={InfoCircle} size="sm" color="tertiary">
				{name}
			</Button>
			<Popover
				size="sm"
				className="min-w-xs px-3 py-1.5"
				containerPadding={16}
				placement="bottom start"
			>
				{author ? (
					<p className="text-xs">
						Author:{' '}
						{authorUrl ? (
							<a
								className="inline-flex items-center gap-1"
								href={authorUrl}
								target="_blank"
								rel="noopener noreferrer"
							>
								{author} <LinkExternal01 className="size-3" />
							</a>
						) : (
							author
						)}
					</p>
				) : null}
				{license ? <p className="text-xs">License: {license}</p> : null}
			</Popover>
		</DialogTrigger>
	)
}
